import React, { useState, useEffect } from 'react';
import useTranslation from 'Hooks/useTranslation';
import { MenuItem, Alert } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import AlertMessage from 'Components/Alert';
import Modal from 'Components/Modal';
import Options from 'Components/Options';
import TextInput from 'Components/FormComponents/TextInput';
import { NO_EMPTY_NO_EMPTY_SPACES } from 'Constants/Regex';
import ModalInformation from '../../Components/ModalInformation';
import useModal from '../../Hooks/useModal';
import useLesson from '../../Hooks/useLesson';
import useEvaluation from '../../Hooks/useEvaluation';
import Title from '../../Components/Title';
import { FormContainer, nameStyle, toolTipStyle } from './style';

function LessonEval({
  addLessonSession,
  module,
  updateLesson,
  currentPositionLesson,
  deleteLesson,
  updateLessonSessionData,
  alert,
  setAlert,
}) {
  const lesson = module.lessons[currentPositionLesson];
  const [formData, setFormData] = useState({
    evaluationName: lesson?.name || '',
  });
  const [unchanged, setUnchanged] = useState(true);
  const [errors, setErrors] = useState();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const { t2 } = useTranslation('EditCourse');
  const { openModal, setOpenModal } = useModal();

  useEffect(() => {
    if (alert) {
      setAlertMessage(t2(`${alert}`));
      setAlertOpen(true);
      setTimeout(() => {
        setAlert('');
      }, 2000);
    }
  }, [alert]);

  const { isDraft, setIsDraft, onDelete } = useLesson({
    module,
    updateLesson,
    lesson,
    deleteLesson,
  });

  const { onCreateEvaluation, onUpdateEvaluation } = useEvaluation({
    addLessonSession,
    module,
    updateLesson,
    updateLessonSessionData,
    isDraft,
  });

  const enableButton = () => {
    if (lesson?.id) return t2('SaveChanges');

    return t2('Save');
  };

  const handleModalAccept = async () => {
    setOpenModal(false);

    if (lesson?.id) {
      await onUpdateEvaluation({ ...formData, id: lesson.id });

      return;
    }

    onCreateEvaluation(formData);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleChange = event => {
    setUnchanged(false);
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const validate = () => {
    const temp = {};
    temp.evaluationName = formData.evaluationName.match(NO_EMPTY_NO_EMPTY_SPACES) ? t2('FormErrorExamName') : '';
    setErrors({
      ...temp,
    });

    return Object.values(temp).every(x => x === '');
  };

  const checkValidation = () => {
    const isValid = validate();
    if (isValid) {
      setOpenModal(true);
    }
  };

  return (
    <div>
      <Title
        name={t2('LessonEval')}
        subTitle={t2('LessonEvalSubtitle')}
        textButton={enableButton()}
        check={isDraft}
        setCheck={setIsDraft}
        setUnchanged={setUnchanged}
        checkText={t2('Draft')}
        checkInfo={t2('DraftCondition')}
        checkDisabled={false}
        setOpenModal={checkValidation}
        buttonDisabled={unchanged}
      >
        <Options Icon={<MoreVert />} disabledEffect>
          <MenuItem onClick={onDelete}>{t2('DeleteLesson')}</MenuItem>
        </Options>
      </Title>
      <FormContainer>
        <TextInput
          name="evaluationName"
          label={t2('LabelManualEvaluation')}
          color="MexlogGreen"
          value={formData?.evaluationName}
          onChange={handleChange}
          style={nameStyle}
          errortext={errors?.evaluationName}
        />
        <Alert severity="info" style={{ width: '95%', marginTop: '3rem' }}>
          <div style={toolTipStyle}>{t2('LessonEvalToolTip')}</div>
        </Alert>
      </FormContainer>
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <ModalInformation accept={handleModalAccept} cancel={handleModalClose} title={t2('ModalTitleEvaluation')} />
        }
      />
      <AlertMessage message={alertMessage} open={alertOpen} setOpen={setAlertOpen} />
    </div>
  );
}

export default LessonEval;
